import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FaceDrawer from "./modules/FaceDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import SelectTenantAiDeviceModal from "./SelectTenantAiDeviceModal";
import { httpAction } from '@api/manage';
export default {
  name: 'FaceList',
  mixins: [JeecgListMixin],
  components: {
    FaceDrawer: FaceDrawer,
    SelectTenantAiDeviceModal: SelectTenantAiDeviceModal
  },
  data: function data() {
    return {
      pagePath: '/ai/face',
      pageTitle: 'AI人脸',
      userTree: [],
      //人员信息
      isorter: {
        column: 'tick',
        order: 'desc'
      },
      url: {
        addFace: '/ai/face/pushFace'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'faceId',
        colName: 'face_id',
        title: '人脸id',
        align: 'center'
      }, {
        dataIndex: 'tick',
        colName: 'tick',
        title: '时间',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '姓名',
        align: 'center'
      }, {
        dataIndex: 'sex_dictText',
        colName: 'sex',
        title: '性别',
        align: 'center'
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '人脸类别',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '关联账号',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTreeList();
  },
  computed: {},
  methods: {
    onDateTick: function onDateTick(value, dateArray) {
      this.queryParam.sdate = dateArray[0];
      this.queryParam.edate = dateArray[1];
    },
    // 用户树下拉
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handlePush: function handlePush(faceId) {
      this.$refs.SelectTenantAiDeviceModal.add(faceId);
    },
    // 子modal回调
    choseTenantAiDevice: function choseTenantAiDevice(tenantAiDeviceList) {
      var that = this;
      var method = 'post';
      var list = [];
      tenantAiDeviceList.forEach(function (e) {
        var param = {};
        param.faceId = e.faceId;
        param.aiDeviceCode = e.aiDeviceCode;
        list.push(param);
      });
      httpAction(this.url.addFace, list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};